<template>
  <div v-if="hasAdvantages"
    class="advantages"
  >
    <h2 class="advantages__title">
      Наши преимущества
    </h2>
    <vue-client-only>
      <div class="advantages__inner">
        <swiper
          class="advantages__slider"
          v-if="isSliderMode"
          :items="ADVANTAGES"
          v-slot="{ item }"
          dots
          :slides-to-show="adaptive.isMobile ? 1 : 2"
        >
          <advantage
            class="advantages__item"
            :data="item"
          />
        </swiper>

        <template
          v-else
        >
          <advantage
            class="advantages__item"
            v-for="advantage in ADVANTAGES"
            :key="advantage.id"
            :data="advantage"
          />
        </template>
      </div>
    </vue-client-only>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Advantage from '@/components/advantage/advantage.vue';
import Swiper from '@kit/swiper/swiper.vue';
import VueClientOnly from 'vue-client-only';

const advantages = 'advantage_main';

export default {
  name: 'advantage_main',

  components: { 
    Advantage,
    Swiper,
    VueClientOnly,
  },

  inject: ['adaptive'],

  computed: {
    ADVANTAGES() {
      const totalAdvantages = this.$store.state.banners[advantages] || [];
      // если вдруг в слоте окажется больше 5-ти баннеров - обрезаем
      return totalAdvantages.slice(0, 5);
    },
    hasAdvantages() {
      return !!this.ADVANTAGES.length;
    },
    isSliderMode() {
      return !this.adaptive.isDesktop;
    },
  },

  methods: {
    ...mapActions('banners', ['getBanners']),
  },

  serverPrefetch() {
    return this.getBanners({ slots: [advantages], withCategory: false} );
  },
};
</script>

<style lang="scss">
.advantages {
  &__title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 300;
    margin-bottom: 24px;

    @include breakpoint("desktop") {
      font-size: 40px;
      line-height: 48px;
      margin-bottom: 32px;
    }
  }

  &__inner {
    display: flex;
  }

  &__slider {
    width: 100%;
  }

  &__item {
    border-right-width: 0;
    min-height: 148px;

    @include breakpoint("desktop") {
      flex: 1;
      min-height: 360px;
    }

    &:last-child {
      border-right-width: 1px;
    }
  }
}
</style>
